import storage from "redux-persist/lib/storage"; // Local Storage
import sessionStorage from "redux-persist/lib/storage/session"; // Session Storage

export const getStorage = (key: string) => {
  //?=== Define session storage slices by key or slice name pattern===
  //?=== Add more slice names here for session-based persistence===
  const sessionStorageSlices = ["orderSessionStorage"];

  // If the slice should be persisted in sessionStorage
  if (sessionStorageSlices.includes(key)) {
    return sessionStorage;
  }

  // Default to localStorage
  return storage;
};
